import React from 'react';
import styled from 'styled-components';
import { FaLinkedin, FaTwitter, FaFacebook, FaInstagram } from 'react-icons/fa';
import { Link } from 'react-scroll';

const FooterContainer = styled.footer`
  background: linear-gradient(135deg, #1e293b, #0f172a);
  color: #f8fafc;
  padding: 60px 0 30px;
`;

const FooterWrapper = styled.div`
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 40px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    text-align: center;
  }
`;

const FooterColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

const FooterLogo = styled.div`
  margin-bottom: 20px;
  
  img {
    height: 70px;
    filter: brightness(0) invert(1);
  }
`;

const FooterDescription = styled.p`
  margin-bottom: 20px;
  font-size: 0.95rem;
  line-height: 1.6;
  color: #cbd5e1;
  max-width: 300px;

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

const FooterTitle = styled.h4`
  font-size: 1.2rem;
  margin-bottom: 20px;
  font-weight: 700;
  position: relative;
  padding-bottom: 12px;
  color: white;
  
  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 40px;
    height: 3px;
    background: linear-gradient(90deg, #3b82f6, #8b5cf6);
    border-radius: 10px;
  }

  @media (max-width: 768px) {
    &:after {
      left: 50%;
      transform: translateX(-50%);
    }
  }
`;

const FooterLinks = styled.ul`
  list-style: none;
  
  li {
    margin-bottom: 12px;
  }
  
  a {
    color: #cbd5e1;
    transition: all 0.3s ease;
    font-size: 0.95rem;
    
    &:hover {
      color: #3b82f6;
      padding-left: 5px;
    }
  }

  @media (max-width: 768px) {
    a:hover {
      padding-left: 0;
    }
  }
`;

const ContactInfo = styled.div`
  margin-bottom: 12px;
  display: flex;
  align-items: flex-start;
  
  svg {
    margin-right: 10px;
    margin-top: 5px;
    color: #3b82f6;
  }

  @media (max-width: 768px) {
    justify-content: center;
    
    svg {
      margin-right: 8px;
    }
  }
`;

const SocialIcons = styled.div`
  display: flex;
  gap: 15px;
  margin-top: 20px;
  
  a {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: rgba(203, 213, 225, 0.1);
    transition: all 0.3s ease;
    
    svg {
      font-size: 18px;
      color: #cbd5e1;
      transition: all 0.3s ease;
    }
    
    &:hover {
      background: #3b82f6;
      transform: translateY(-3px);
      
      svg {
        color: #fff;
      }
    }
  }

  @media (max-width: 768px) {
    justify-content: center;
  }
`;

const Copyright = styled.div`
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
  padding-top: 30px;
  margin-top: 40px;
  border-top: 1px solid rgba(203, 213, 225, 0.1);
  text-align: center;
  font-size: 0.9rem;
  color: #94a3b8;
`;

const Footer = () => {
  return (
    <FooterContainer>
      <FooterWrapper>
        <FooterColumn>
          <FooterLogo>
            <img src="/Websigma_logo.png" alt="Websigma Logo" />
          </FooterLogo>
          <FooterDescription>
            Delivering innovative web solutions to help businesses establish a powerful online presence and achieve their digital goals.
          </FooterDescription>
          <SocialIcons>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
              <FaLinkedin />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
              <FaTwitter />
            </a>
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
              <FaFacebook />
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
              <FaInstagram />
            </a>
          </SocialIcons>
        </FooterColumn>
        
        <FooterColumn>
          <FooterTitle>Quick Links</FooterTitle>
          <FooterLinks>
            <li><Link to="home" spy={true} smooth={true} offset={-80} duration={500}>Home</Link></li>
            <li><Link to="about" spy={true} smooth={true} offset={-80} duration={500}>About Us</Link></li>
            <li><Link to="services" spy={true} smooth={true} offset={-80} duration={500}>Our Services</Link></li>
            <li><Link to="projects" spy={true} smooth={true} offset={-80} duration={500}>Projects</Link></li>
            <li><Link to="contact" spy={true} smooth={true} offset={-80} duration={500}>Contact Us</Link></li>
          </FooterLinks>
        </FooterColumn>
        
        <FooterColumn>
          <FooterTitle>Services</FooterTitle>
          <FooterLinks>
            <li><a href="#">Web Development</a></li>
            <li><a href="#">E-Commerce Solutions</a></li>
            <li><a href="#">UI/UX Design</a></li>
            <li><a href="#">Digital Marketing</a></li>
            <li><a href="#">Mobile App Development</a></li>
          </FooterLinks>
        </FooterColumn>
        
        <FooterColumn>
          <FooterTitle>Contact Us</FooterTitle>
          <ContactInfo>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
              <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"/>
            </svg>
            <p>Mallikatte, Mangalore, Karnataka, India</p>
          </ContactInfo>
          <ContactInfo>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
              <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2zm13 2.383-4.708 2.825L15 11.105V5.383zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741zM1 11.105l4.708-2.897L1 5.383v5.722z"/>
            </svg>
            <p>bharath@websigma.in</p>
          </ContactInfo>
          <ContactInfo>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
              <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"/>
            </svg>
            <p>91+ 9900367739</p>
          </ContactInfo>
        </FooterColumn>
      </FooterWrapper>
      
      <Copyright>
        <p>&copy; {new Date().getFullYear()} Websigma. All rights reserved.</p>
      </Copyright>
    </FooterContainer>
  );
};

export default Footer;
